import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@awesome.me/kit-70c1f0055f/icons/classic/light";

interface TagDropdownProps {
  visibleTags: string[];
  highlightedTagIndex: number;
  onSelect: (tag: string) => void;
  onMouseEnterIndex?: (idx: number) => void;
}

export const TagDropdown: React.FC<TagDropdownProps> = ({
  visibleTags,
  highlightedTagIndex,
  onSelect,
  onMouseEnterIndex,
}) => {
  if (!visibleTags.length) return null;
  return (
    <div className="absolute w-96 left-0 mt-2 bg-white dark:bg-gray-800 rounded-2xl p-2 shadow-lg z-50  overflow-y-auto">
      {visibleTags.map((tag, idx) => (
        <button
          key={tag}
          type="button"
          onClick={() => onSelect(tag)}
          onMouseEnter={
            onMouseEnterIndex ? () => onMouseEnterIndex(idx) : undefined
          }
          className={`block w-full text-left px-3 py-2 border-0 bg-transparent rounded-xl transition-colors
            hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200
            ${
              highlightedTagIndex === idx
                ? "bg-indigo-400! text-white  dark:bg-indigo-800  dark:text-indigo-200"
                : ""
            }`}
        >
          {tag}
        </button>
      ))}
    </div>
  );
};
